import { useEffect, useState } from 'react'
import { GetRCNOptionsForUser } from '../../../services/UserManagementService'
import { Box, CircularProgress, Typography } from '@mui/material'
import { OrgCard } from './OrgCard'
import type { OrganizationOption } from '../../../models/requestObjects/CommonObjects'
import { handleApiResponse } from '../../../utils/apiHelpers'

interface Props {
  onRCNSelect: (rcn: OrganizationOption) => void
  isImplementationPhase: boolean
}

export const RCNSelection = (props: Props): JSX.Element => {
  const [rcns, setRcns] = useState<OrganizationOption[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const getRcns = async (): Promise<void> => {
      const rcnOrgs = await handleApiResponse(GetRCNOptionsForUser())
      if (rcnOrgs != null) setRcns(rcnOrgs.sort((a, b) => a.name.localeCompare(b.name)))
      setIsLoading(false)
    }

    void getRcns()
  }, [])

  return (
    <Box data-testid="rcn-selection" sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: '44px'
    }}
    >
      <Typography variant='h4'>RCNs</Typography>
      <Box sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '33px'
      }}
      >
        {isLoading
          ? <CircularProgress />
          : rcns?.map((rcn, index) =>
            <OrgCard
              index={index}
              key={rcn.id}
              name={rcn.name}
              imageKey={rcn.imageKey}
              buttonText={`View ${props.isImplementationPhase ? 'Implementation' : 'Planning'}`}
              onClick={() => { props.onRCNSelect(rcn) }}
              dataTestId='rcn-card'
              buttonDataTestId='view-annual-plans-button'
            />)}
      </Box>
    </Box>
  )
}
